import { CurrencyType } from '@wolffun/system-currency';
import BN from 'bn.js';
import React from 'react';
import { CONVERT_THC_PAYMENT_ADDRESS } from '@conversionProgram/src/constants';
import { EipError } from '@conversionProgram/src/redux/types';
import { useTypedSelector } from '@conversionProgram/src/redux/utils';
import { getAllowance, removeAllowance } from '@conversionProgram/src/utils/ethereum';
import { WarningModalName } from './config';
import ConversionWarningModal from './ConversionWarningModal';
import TransactionErrorModal from './TransactionErrorModal';

const noop = () => {};

const NotificationContext = /*#__PURE__*/React.createContext({
  conversionWarning: noop,
  openModal: noop,
  closeModal: noop
});

const NotificationProvider = ({
  children
}) => {
  const userProfile = useTypedSelector(state => state.userProfile.user);
  const [modal, setModal] = React.useState(null);
  const [conversionInfo, setConversionInfo] = React.useState();
  const [error, setError] = React.useState();
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setModal(null);
    setConversionInfo(undefined);
    setError(undefined);
  }, []);

  const warning = () => {
    setModal(WarningModalName.CONVERSION_WARNING);
  };

  const context = React.useMemo(() => {
    return {
      modal: modal || undefined,
      openModal,
      closeModal,
      conversionWarning: warning
    };
  }, [modal]);
  React.useEffect(() => {
    const checkAllowance = async () => {
      const contract = CONVERT_THC_PAYMENT_ADDRESS;

      if (userProfile !== null && userProfile !== void 0 && userProfile.address) {
        const {
          error,
          allowance
        } = await getAllowance({
          fromAddress: userProfile.address,
          contractAddress: contract,
          token: CurrencyType.THC
        });
        const allowanceBN = new BN((allowance === null || allowance === void 0 ? void 0 : allowance.value) || '0');

        if (error === EipError.NO_ERROR && allowanceBN.gtn(0)) {
          openModal(WarningModalName.CONVERSION_WARNING);
          setConversionInfo({
            fromAddress: userProfile.address,
            contractAddress: contract,
            token: CurrencyType.THC
          });
        }
      }
    };

    checkAllowance();
  }, [openModal, userProfile === null || userProfile === void 0 ? void 0 : userProfile.address]); // Render the current modal

  const renderModal = () => {
    switch (modal) {
      case WarningModalName.CONVERSION_WARNING:
        return /*#__PURE__*/React.createElement(ConversionWarningModal, {
          onClose: () => {
            closeModal();
          },
          onPress: async () => {
            if (conversionInfo) {
              const {
                error
              } = await removeAllowance({ ...conversionInfo
              });

              if (error !== EipError.NO_ERROR) {
                setError(error);
                openModal(WarningModalName.TRANSACTION_ERROR);
              } else {
                closeModal();
              }
            }
          }
        });

      case WarningModalName.TRANSACTION_ERROR:
        return error && /*#__PURE__*/React.createElement(TransactionErrorModal, {
          onClose: closeModal,
          error: error
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useNotification = () => {
  const {
    modal,
    conversionWarning
  } = React.useContext(NotificationContext);
  return {
    modal,
    conversionWarning
  };
};
export default NotificationProvider;